export default __webpack_public_path__ + "static/media/undo-24px.c27dcf64.svg";